export default {
  active_panel: false,
  active_class: '',
  leaving_class: '',
  message: ''
}